import { Remark } from 'components'
import { Table } from '@sar/component'

async function fetchData (params, store) {
  const result = await store.externals.api.get(`/design`, {
    params: Object.assign(params, {
      page: params.current,
      size: params.pageSize,
    })
  })

  return {
    success: true,
    data: result.data,
    total: result.totals,
  }
}

export default function ({ store, navigator }) {
  const columns = [
    {
      title: '序号',
      dataIndex: 'id',
    },
    {
      title: '客户姓名',
      dataIndex: 'customerName',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '客户姓名' }),
    },
    {
      title: '联系电话',
      dataIndex: 'customerPhone',
      render: _ => _.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2'),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '联系电话' }),
    },
    {
      title: '地址',
      dataIndex: 'customerAddress',
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ placeholder: '地址' }),
    },
    {
      title: '来源',
      dataIndex: 'sourceId',
      valueType: 'treeSelect',
      hideInTable: true,
      request: () => store.externals.api.get(`/constant/source`),
      formItemProps: () => ({ label: false }),
      fieldProps: () => ({ fieldNames: { value: 'id', label: 'source' }, placeholder: '来源' }),
    },
    {
      title: '来源',
      dataIndex: 'customerSource',
    },
    {
      title: '跟踪员',
      dataIndex: 'saleName',
    },
    {
      title: '设计文件上传',
      dataIndex: 'designerFile',
      render: (_, data) => <a className='text-blue-600' onClick={() => navigator.to(`/design/list/upload/${data.id}`, `上传设计文件`)}>{data.upDesign ? '查看' : '上传'}</a>,
    },
    {
      title: '设计师',
      dataIndex: 'designerName',
    },
    {
      title: '订单状态',
      dataIndex: 'status',
      valueType: 'select',
      valueEnum: store.config.getConstantEnums(`OrderStatus`),
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      valueType: 'datetime',
    },
  ]

  const cols = React.useMemo(() => {
    let showSearch = [
        'customerName'
      , 'customerPhone'
      , 'customerAddress'
      , 'sourceId'
    ]

    return columns.map(column => {
      if (showSearch.includes(column.dataIndex)) {
        return Object.assign(column)
      }

      else {
        return Object.assign(column, { hideInSearch: true })
      }
    })
  }, [])

  const rowActions = [
    {
      danger: true,
      name: '确定',
      confirmType: 'modal',
      confirmMessage: '确定后所有设计上传的资料不可更改订单会进入报价环节。',
      visible: () => store.identity.hasPermission('/design/list:submit'),
      onConfirm: (data, handles) => store.externals.api.put(`/design/submit/${data.id}`).then(() => handles.current.reload()),
    },
    {
      name: '查看备注',
      form: props => <Remark {...props}/>,
    },
    {
      danger: true,
      name: '删除',
      confirmType: 'modal',
      confirmMessage: '您确定删除这个设计吗？',
      visible: () => store.identity.hasPermission('/design/list:delete'),
      onConfirm: (data, handles) => store.externals.api.delete(`/design/${data.id}`).then(() => handles.current.reload()),
    },
  ]

  return <div className='p-4'>
    <Table
      title='设计部列表'
      columns={cols}
      rowActions={rowActions}
      request={params => fetchData(params, store)}
      scroll={{ }}
      search={{ labelWidth: 'auto', defaultCollapsed: true, span: Object.assign({}, store.config.responsive, { xxl: 4 }) }}
    />
  </div>
}
